module.exports = "pegasus_template/assets/two-column-image-text-button-preview.png";